import { translations } from '../../../configs/translations'
import { useHoverSound } from '../../../hooks/useHoverSound'
import { useStore } from '../../../store/store'
import './LongButton.css'

interface LongButtonProps {
    text: string;
    onClick: () => void;
    isShining?: boolean;
    isComingSoon?: boolean;
    disabled?: boolean;
}

export const LongButton = ({ text, onClick, isShining, isComingSoon, disabled }: LongButtonProps) => {
    const hoverProps = useHoverSound('/sounds/hover3.mp3');
    const language = useStore(state => state.language) as keyof typeof translations;
    const t = translations[language];

    return (
        <div>
            <button
                className={`long-button ${isShining ? 'shining' : ''} ${isComingSoon ? 'coming-soon' : ''} ${disabled ? 'disabled' : ''}`}
                onClick={onClick}
                disabled={disabled}
                {...hoverProps}
            >
                {text}
            </button>
            {isComingSoon &&
                <div className='coming-soon'>
                    <p>{t.coming_soon}</p>
                </div>
            }
        </div>
    );
};
